import { RoleFunction } from '@eagle/common';
import { Card, CardContent, Divider, Stack } from '@ethings/ui-toolkit';
import { TabContext } from '@mui/lab';
import { Box } from '@mui/material';
import { FC, type JSX } from 'react';
import { useAuthenticated } from '../../auth';
import { NoPermission } from './no-permission';

interface Props {
  'data-testid'?: string;
  displayOnCard: boolean;
  mediaOverlay: JSX.Element;
  selectedTab: string;
  tabPanels: JSX.Element;
  tabs: JSX.Element;
  viewButton: JSX.Element;
}

export const MediaCardLayoutDesktop: FC<Props> = ({
  displayOnCard,
  mediaOverlay,
  selectedTab,
  tabPanels,
  tabs,
  viewButton,
  ...props
}) => {
  const { userInfo } = useAuthenticated();
  const hasMediaPermissions = userInfo.hasRoleFunction(RoleFunction.MEDIA_VIEWER);
  const hideCardProperties = !displayOnCard ? { boxShadow: 'none' } : {};

  if (!hasMediaPermissions) return <NoPermission sx={hideCardProperties} />;

  return (
    <Card data-testid={props['data-testid']} style={hideCardProperties}>
      <CardContent data-testid="card-content" style={{ padding: 0 }}>
        <TabContext value={selectedTab}>
          <Stack>
            {tabs}
            <Divider />
          </Stack>
          {tabPanels}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: 2, pt: 1 }}>
            {viewButton}
          </Box>
          {mediaOverlay}
        </TabContext>
      </CardContent>
    </Card>
  );
};
